import { configureStore } from "@reduxjs/toolkit";
import { persistStore, persistCombineReducers, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import authReducer from './reducers/auth/authReducer';
import userReducer from './reducers/user/userReducer';
import usersReducer from './reducers/users/usersReducer';
import lotsReducer from './reducers/lots/lotsReducer';
import guidesReducer from './reducers/guides/guidesReducer';

const authPersistConfig = {
  key: 'auth',
  storage,
};

const userPersistConfig = {
  key: 'user',
  storage,
};

const rootPersistConfig = {
  key: 'root',
  storage,
  whitelist: ['auth', 'user'] 
};

const rootReducer = persistCombineReducers(rootPersistConfig, {
  auth: persistReducer(authPersistConfig, authReducer),
  user: persistReducer(userPersistConfig, userReducer),
  users: usersReducer,
  lots: lotsReducer,
  guides: guidesReducer
});

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export const persistor = persistStore(store);